import type { CustomIconProps } from '../types';

const ExpandArrowsCircle = ({ width, height, color }: CustomIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '24'}
        height={height || '24'}
        viewBox="0 0 24 24"
        fill="none"
    >
        <path
            d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
            fill={color ?? '#F6F5F6'}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.5001 6C13.2239 6 13.0001 6.22386 13.0001 6.5C13.0001 6.77614 13.2239 7 13.5001 7H16.2374L13.1433 10.1496C12.9498 10.3466 12.9526 10.6632 13.1496 10.8567C13.3466 11.0502 13.6632 11.0474 13.8567 10.8504L17.0001 7.65057V10.5C17.0001 10.7761 17.2239 11 17.5001 11C17.7762 11 18.0001 10.7761 18.0001 10.5V7.5C18.0001 6.67157 17.3285 6 16.5001 6H13.5001Z"
            fill="#414042"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.7627 17L10.5 17C10.7761 17 11 17.2239 11 17.5C11 17.7762 10.7761 18 10.5 18L7.5 18C6.67157 18 6 17.3285 6 16.5V13.5C6 13.2239 6.22386 13 6.5 13C6.77614 13 7 13.2239 7 13.5L7 16.3495L10.1434 13.1496C10.3369 12.9526 10.6535 12.9498 10.8505 13.1433C11.0475 13.3368 11.0503 13.6534 10.8568 13.8504L7.7627 17Z"
            fill="#414042"
        />
    </svg>
);

export default ExpandArrowsCircle;
